module.exports = __webpack_public_path__ + "img/Avatar1.00171378.png";